import { render } from "./blogs-block.vue?vue&type=template&id=47f8dc86&scoped=true"
import script from "./blogs-block.vue?vue&type=script&lang=js"
export * from "./blogs-block.vue?vue&type=script&lang=js"

import "./blogs-block.vue?vue&type=style&index=0&id=47f8dc86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f8dc86"]])

export default __exports__